

const NftsData = [
{
  id:1,
  // image:NftsImage1,
  name:'Battle_SB_YB',
  amount:'1000',
  time:'Latest Bid',
  price:'$1.5702',
  ownerAddress:'0xe4feb387cb1daff4bf9108581b116e5fa737bea2',
  contractAddress:'0xcfe2cd1e76ef398b137f9ec8031b87982e18e4ac',
  TokenId:'#1234',
  miningHashRate:100,
  assetProtocol:'ERC721',
  assetPublicchain:'BTC',
  BreedCount:'0/3',
  startPrice:'1,000,000',
  priceinDoller:'$149',
  hash:'0x6e0bd49a3101f59d0696c2129c9951ee952430514a98621537a40453245db667',
},
{
  id:2,
  // image:NftsImage2,
  name:'Synapse',
  amount:'1000',
  time:'Latest Bid',
  price:'$1.5702',
  ownerAddress:'0xe4feb387cb1daff4bf9108581b116e5fa737bea2',
  contractAddress:'0xcfe2cd1e76ef398b137f9ec8031b87982e18e4ac',
  TokenId:'#1234',
  miningHashRate:100,
  assetProtocol:'ERC721',
  assetPublicchain:'ETH',
  startPrice:'1,000,000',
  priceinDoller:'$149',
  BreedCount:'0/3',
  hash:'0x6e0bd49a3101f59d0696c2129c9951ee952430514a98621537a40453245db667'
},
{
  id:3,
  // image:NftsImage1,
  name:'Battle_SB_yb',
  amount:'1000',
  time:'Latest Bid',
  price:'$1.5702',
  ownerAddress:'0xe4feb387cb1daff4bf9108581b116e5fa737bea2',
  contractAddress:'0xcfe2cd1e76ef398b137f9ec8031b87982e18e4ac',
  TokenId:'#1234',
  miningHashRate:100,
  assetProtocol:'ERC721',
  assetPublicchain:'BTC',
  startPrice:'1,000,000',
  priceinDoller:'$149',
  BreedCount:'0/3',
  hash:'0x6e0bd49a3101f59d0696c2129c9951ee952430514a98621537a40453245db667'
},
{
 id:4,
//  image:NftsImage2,
 name:'Synapse',
 amount:'1000',
 time:'Latest Bid',
 price:'$1.5702',
 ownerAddress:'0xe4feb387cb1daff4bf9108581b116e5fa737bea2',
 contractAddress:'0xcfe2cd1e76ef398b137f9ec8031b87982e18e4ac',
 TokenId:'#1234',
 miningHashRate:100,
 assetProtocol:'ERC721',
 assetPublicchain:'BTC',
 startPrice:'1,000,000',
 priceinDoller:'$149',
 BreedCount:'0/3',
 hash:'0x6e0bd49a3101f59d0696c2129c9951ee952430514a98621537a40453245db667'
},
{
  id:5,
  // image:NftsImage1,
  name:'Synapse',
  amount:'1000',
  time:'Latest Bid',
  price:'$1.5702',
  ownerAddress:'0xe4feb387cb1daff4bf9108581b116e5fa737bea2',
  contractAddress:'0xcfe2cd1e76ef398b137f9ec8031b87982e18e4ac',
  TokenId:'#1234',
  miningHashRate:100,
  assetProtocol:'ERC721',
  assetPublicchain:'ETH',
  startPrice:'1,000,000',
  priceinDoller:'$149',
  BreedCount:'0/3',
  hash:'0x6e0bd49a3101f59d0696c2129c9951ee952430514a98621537a40453245db667'
 },
 {
  id:6,
  // image:NftsImage2,
  name:'Battle_SB_yb',
  amount:'1000',
  time:'Latest Bid',
  price:'$1.5702',
  ownerAddress:'0xe4feb387cb1daff4bf9108581b116e5fa737bea2',
  contractAddress:'0xcfe2cd1e76ef398b137f9ec8031b87982e18e4ac',
  TokenId:'#1234',
  miningHashRate:100,
  assetProtocol:'ERC721',
  assetPublicchain:'BTC',
  startPrice:'1,000,000',
  priceinDoller:'$149',
  BreedCount:'0/3',
  hash:'0x6e0bd49a3101f59d0696c2129c9951ee952430514a98621537a40453245db667'
},
{
  id:7,
  // image:NftsImage1,
  name:'Synapse',
  amount:'1000',
  time:'Latest Bid',
  price:'$1.5702',
  ownerAddress:'0xe4feb387cb1daff4bf9108581b116e5fa737bea2',
  contractAddress:'0xcfe2cd1e76ef398b137f9ec8031b87982e18e4ac',
  TokenId:'#1234',
  miningHashRate:100,
  assetProtocol:'ERC721',
  assetPublicchain:'ETH',
  startPrice:'1,000,000',
  priceinDoller:'$149',
  BreedCount:'0/3',
  hash:'0x6e0bd49a3101f59d0696c2129c9951ee952430514a98621537a40453245db667'
 },
 {
  id:8,
  // image:NftsImage2,
  name:'Battle_SB_yb',
  amount:'1000',
  time:'Latest Bid',
  price:'$1.5702',
  ownerAddress:'0xe4feb387cb1daff4bf9108581b116e5fa737bea2',
  contractAddress:'0xcfe2cd1e76ef398b137f9ec8031b87982e18e4ac',
  TokenId:'#1234',
  miningHashRate:100,
  assetProtocol:'ERC721',
  assetPublicchain:'BTC',
  startPrice:'1,000,000',
  priceinDoller:'$149',
  BreedCount:'0/3',
  hash:'0x6e0bd49a3101f59d0696c2129c9951ee952430514a98621537a40453245db667'
},
];

export default NftsData;